import React, { useEffect, useState } from "react";
import { ExportOutlined, SearchOutlined } from "@ant-design/icons";
import { useTypedSelector } from "../../store";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Button,
  DatePicker,
  Image,
  Input,
  Modal,
  Skeleton,
  Space,
  Table,
} from "antd";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { ColumnsType } from "antd/es/table";
import { useDispatch } from "react-redux";
import {
  approvalLeaveAllRequest,
  approvalLeaveRequest,
  getLeaveReportRequest,
} from "../../slices/leave";

interface DataType {
  attendanceId: string;
  date: string;
  employeeId: string;
  name: string;
  department: string;
  leaveCode: string;
  leaveName: string;
  leaveId: string;
  approval: string;
  approvalId: string;
  startDate: string;
  countDay: string;
  document: string | null;
  leaveReason: string;
  requestStatus: string;
  decisionNotes: string;
  createdAt: string;
  updatedAt: string;
}

const Leave: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authData, isLogin, lists, loading, isChange, approveAll } =
    useTypedSelector((state) => {
      return {
        authData: state.Auth.loginData,
        isLogin: state.Auth.isLogin,
        lists: state.Leave.reportLeaves,
        loading: state.Leave.pageIsLoading,
        isChange: state.Leave.approveLeaves,
        approveAll: state.Leave.approveAll,
      };
    });
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState<any>(dayjs().startOf("month"));
  const [endDate, setEndDate] = useState<any>(dayjs().endOf("month"));
  const [filteredData, setFilteredData] = useState<any[]>(lists);

  console.log(authData, isLogin);

  const handleApprove = (id: string, status: string) => {
    let payload = {};
    if (status === "rejected") {
      payload = { id: id, status: status, rejectedNotes: "Di Tolak oleh HC" };
    } else {
      payload = { id: id, status: status, rejectedNotes: "Di setujui oleh HC" };
    }
    // Tambahkan logic untuk API call atau Redux dispatch di sini

    dispatch(approvalLeaveRequest(payload) as any);
  };

  useEffect(() => {
    if (!isLogin) {
      navigate("/login");
    } else {
      dispatch(
        getLeaveReportRequest({
          startdate: startDate.format("YYYY-MM-DD"),
          enddate: endDate.format("YYYY-MM-DD"),
        }) as any
      );
    }
  }, [isLogin, dispatch, navigate, startDate, endDate, isChange, approveAll]);

  useEffect(() => {
    // Perbarui filteredData setiap kali employees berubah
    if (lists.length > 0) {
      console.log("LIST", lists);

      setFilteredData(lists);
    } else {
      setFilteredData([]);
    }
  }, [lists]);

  const handleApproveAll = () => {
    dispatch(approvalLeaveAllRequest() as any);
  };

  const handleSearchText = (value: string) => {
    setSearchText(value);
    const filtered = lists.filter(
      (leave) =>
        leave.name.toLowerCase().includes(value.toLowerCase()) ||
        leave.employeeId.toLowerCase().includes(value.toLowerCase()) ||
        leave.department.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };
  const handleSearch = () => {
    //   setIsLoading(true);
    // Logika untuk pencarian berdasarkan tanggal
    console.log(
      "Searching from",
      startDate.format("YYYY-MM-DD"),
      "to",
      endDate.format("YYYY-MM-DD")
    );
    dispatch(
      getLeaveReportRequest({
        startdate: startDate.format("YYYY-MM-DD"),
        enddate: endDate.format("YYYY-MM-DD"),
      }) as any
    ).then((res: any) => {
      // setIsLoading(false)
      setFilteredData(res.payload);
    });
  };

  console.log("FD", filteredData);

  // const handleExportToExcel = () => {
  //   // Fungsi untuk eksport ke Excel
  //   console.log("Export to Excel");
  //   const worksheet = XLSX.utils.json_to_sheet(
  //     lists.map((item) => ({
  //       employeeId: item.employeeId,
  //       name: item.name,
  //       approval_name: item.approval_name || "--",
  //       schedule_date: item.schedule_date,
  //       location_in: item.location_in,
  //       location_out: item.location_out,
  //       request_status: item.request_status || "--",
  //       rejected_notes: item.rejected_notes || "--",
  //       total_overtime: item.total_overtime || "--",
  //       overtime_start: item.overtime_start || "--",
  //       overtime_end: item.overtime_end || "--",
  //       overtime_notes: item.notes,
  //       time_in: item.time_in || "--",
  //       time_out: item.time_out || "--",
  //       status: item.status,
  //     }))
  //   );

  //   // Buat workbook dan tambahkan worksheet
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  //   // Ekspor workbook ke file Excel
  //   XLSX.writeFile(workbook, "overtimes.xlsx");
  // };

  const handleExportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leaves");
    XLSX.writeFile(workbook, "leave_reports.xlsx");
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
      sorter: (a: any, b: any) =>
        (a.employeeId || "").localeCompare(b.employeeId || ""),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a: any, b: any) => (a.date || "").localeCompare(b.date || ""),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Code",
      dataIndex: "leaveCode",
      key: "leaveCode",
      sorter: (a: any, b: any) =>
        (a.leaveCode || "").localeCompare(b.leaveCode || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Departement",
      dataIndex: "department",
      key: "department",
      sorter: (a: any, b: any) =>
        (a.department || "").localeCompare(b.department || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Leave Name",
      dataIndex: "leaveName",
      key: "leaveName",
      sorter: (a: any, b: any) =>
        (a.leaveName || "").localeCompare(b.leaveName || ""),
    },
    {
      title: "Approval",
      dataIndex: "approval",
      key: "approval",
      sorter: (a: any, b: any) =>
        (a.approval || "").localeCompare(b.approval || ""),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      sorter: (a: any, b: any) => (a.startDate || 0) - (b.startDate || 0),
    },
    {
      title: "Days",
      dataIndex: "countDay",
      key: "countDay",
      sorter: (a: any, b: any) =>
        (a.countDay || "").localeCompare(b.countDay || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Document",
      dataIndex: "document",
      key: "document",
      render: (text: string) =>
        text ? (
          <Image
            width={50}
            src={text}
            preview={{ mask: "Click to Zoom" }} // Zoom hanya saat diklik
          />
        ) : (
          "--"
        ),
    },
    {
      title: "Reason",
      dataIndex: "leaveReason",
      key: "leaveReason",
      sorter: (a: any, b: any) =>
        (a.leaveReason || "").localeCompare(b.leaveReason || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      sorter: (a: any, b: any) =>
        (a.requestStatus || "").localeCompare(b.requestStatus || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Notes",
      dataIndex: "decisionNotes",
      key: "decisionNotes",
      sorter: (a: any, b: any) =>
        (a.decisionNotes || "").localeCompare(b.decisionNotes || ""),
      render: (text: any) => text || "--",
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: DataType) => (
        <>
          <Button
            type="primary"
            onClick={() => handleApprove(record.leaveId, "approved")}
            style={{ marginRight: 10 }}
            disabled={record.requestStatus !== "review"}
          >
            Approve
          </Button>
          <Button
            type="primary"
            onClick={() => handleApprove(record.leaveId, "rejected")}
            disabled={record.requestStatus !== "review"}
            danger
          >
            Reject
          </Button>
        </>
      ),
    },
  ];
  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Space>
          <Input
            placeholder="Search by name or EID"
            value={searchText}
            onChange={(e) => handleSearchText(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ maxWidth: 300 }}
          />
          <DatePicker
            value={startDate}
            onChange={(date) => setStartDate(date ? date : dayjs())}
            placeholder="Start Date"
          />
          <DatePicker
            value={endDate}
            onChange={(date) => setEndDate(date ? date : dayjs())}
            placeholder="End Date"
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
          />
        </Space>
        <div>
          <Button
            style={{
              backgroundColor: "#00A65A",
              borderColor: "#00A65A",
              color: "#fff",
            }}
            icon={<ExportOutlined />}
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={handleApproveAll}
          >
            Approve All
          </Button>
        </div>
      </Space>
      {!loading ? (
        <Table
          columns={columns}
          dataSource={filteredData}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Skeleton active />
      )}
      {/* <Modal
        title="Approve Leave Request"
        visible={isApproveModalVisible}
        onOk={confirmApprove}
        onCancel={() => setIsApproveModalVisible(false)}
      >
        <p>Are you sure you want to approve this leave request?</p>
      </Modal> */}
    </div>
  );
};

export default Leave;
